import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Products from "./pages/Products";
import ProductForm from "./pages/ProductForm";
import Settings from "./pages/Settings";
import Reviews from "./pages/Reviews";
import AdminLayout from "./AdminLayout";
import NotFound from "./pages/NotFound";

export default function AdminRoutes() {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="regi-ster" element={<Register />} />

      <Route element={<AdminLayout />}>
        <Route path="products" element={<Products />} />
        <Route path="products/new" element={<ProductForm />} />
        <Route path="products/:id/edit" element={<ProductForm />} />
        <Route path="reviews" element={<Reviews />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      {/* Catch-all route for unknown paths */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
